(() => {
  const KEY = "boostPFSScrollbackPostion";

  const normalize = (path) =>
    path && path.length > 1 ? path.replace(/\/+$/, "") : path || "";

  let raw = null;
  try {
    raw = sessionStorage.getItem(KEY);
  } catch (error) {
    return;
  }
  if (!raw) return;

  let savedPath = "";
  try {
    const saved = JSON.parse(raw);
    savedPath = new URL(saved.url, window.location.origin).pathname;
  } catch (error) {
    savedPath = "";
  }

  if (savedPath && normalize(savedPath) === normalize(window.location.pathname)) {
    return;
  }

  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {}
})();
